import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, TermFilter, NoticeStatusOptions } from "../../../../../../_helpers/Helpers";
import { usePublicNoticesUIContext } from "../PublicNoticesUIContext";

const prepareFilter = (queryParams, values) => {
  const { term, sender, definition, explanation, createDate, attachmentName, isSent } = values;
  const newQueryParams = { ...queryParams };
  const filter = { sender, definition, explanation, createDate, attachmentName, isSent };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function PublicNoticesFilter() {
  // PublicNotices UI Context
  const publicNoticesUIContext = usePublicNoticesUIContext();
  const publicNoticesUIProps = useMemo(() => {
    return {
      setQueryParams: publicNoticesUIContext.setQueryParams,
      queryParams: publicNoticesUIContext.queryParams,
    };
  }, [publicNoticesUIContext]);
  
  const { currentActiveTerm } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm
    }),
    shallowEqual
  );

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(publicNoticesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, publicNoticesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      publicNoticesUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        sender: "",
        definition: "",
        explanation: "",
        createDate: "",
        attachmentName: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="sender"
                placeholder="Gönderen"
                onBlur={handleBlur}
                value={values.sender}
                onChange={(e) => {
                  setFieldValue("sender", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Gönderen</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="definition"
                placeholder="Tanımı"
                onBlur={handleBlur}
                value={values.definition}
                onChange={(e) => {
                  setFieldValue("definition", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Tanımı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="explanation"
                placeholder="Açıklaması"
                onBlur={handleBlur}
                value={values.explanation}
                onChange={(e) => {
                  setFieldValue("explanation", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Açıklaması</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="createDate"
                placeholder="Tarih"
                onBlur={handleBlur}
                value={values.createDate}
                onChange={(e) => {
                  setFieldValue("createDate", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Tarih</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="attachmentName"
                placeholder="Ek"
                onBlur={handleBlur}
                value={values.attachmentName}
                onChange={(e) => {
                  setFieldValue("attachmentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Ek</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={NoticeStatusOptions}
                value={values.isSent}
                placeholder="Durum"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("isSent", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Durum</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}